import { fetcher } from "matsuri-hooks";
import { login as m2mUsers_v1_login } from "../../endpoints/m2m-users.v1";

export interface LoginInput {
  email: string;
  password: string;
}
// @see https://github.com/matsuri-tech/m2m-users/blob/master/domain/model/common/accessToken.go#L7
export interface LoginResponse {
  accessToken: string;
  expiresAt: number;
  refreshToken: {
    refreshToken: string;
    refreshTokenExpiresAt: number;
  };
}
export const requestLogin = async (input: LoginInput) => {
  return await fetcher<LoginResponse>(m2mUsers_v1_login(), {
    method: "POST",
    body: JSON.stringify(input),
  });
};
